import { Mail, Info } from 'lucide-react';

const Footer = () => {
  return (
    <footer
      data-testid="app-footer"
      className="mt-12 border-t border-[#3D1A1A] bg-[#120505]/70 backdrop-blur-md"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-6 space-y-3">
        <div className="flex items-start gap-3">
          <Info className="w-4 h-4 text-[#FFB800] shrink-0 mt-0.5" />
          <p className="text-xs sm:text-[13px] leading-relaxed text-[#BFA5A5] font-body max-w-3xl">
            Audio plays through YouTube's embedded player. Nothing is hosted on this site, and all rights stay with the labels, composers and performers. Song credits are put together from film soundtrack listings.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <Mail className="w-4 h-4 text-[#FF007F] shrink-0 mt-0.5" />
          <p className="text-xs sm:text-[13px] leading-relaxed text-[#BFA5A5] font-body max-w-3xl">
            If you hold rights to anything here and want it taken off, email{' '}
            <a
              href="mailto:ranjaynikhil@gmail.com"
              className="text-[#FFB800] underline decoration-dotted underline-offset-2 hover:text-[#FF007F]"
              data-testid="footer-takedown-email"
            >
              ranjaynikhil@gmail.com
            </a>{' '}
            and it comes down.
          </p>
        </div>
        <div className="pt-2 flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#5A2418]">
          <span>© Patna Ke Presleys</span>
          <span className="opacity-60">·</span>
          <span>Made with ♥ in Patna</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
